import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import style from "./ScoreCard.module.scss";
import SkeletonLoader from "../../../../components/skeleton-loader";

const ScoreItem = ({ title, amount, chargebacks, totalChargebacks, color }) => {
  let progress = 0;
  if (totalChargebacks > 0) {
    progress = ((chargebacks / totalChargebacks) * 100).toFixed(2);
  }

  const numberOfChargebacks =
    chargebacks === 1
      ? `${chargebacks} chargeback`
      : `${chargebacks} chargebacks`;

  const formattedAmount = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    compactDisplay: "short",
  }).format(Math.abs(amount));

  const getNoChargebacks = () => {
    switch (title.toLowerCase()) {
      case "new":
        return "No new chargebacks";
      case "pending":
        return "No pending chargebacks";
      case "won":
        return "No won chargebacks";
      case "loss":
        return "No lost chargebacks";
      default:
        return "No chargebacks";
    }
  };

  return (
    <div className={style.score_item}>
      <div className={style.title_amount}>
        <span>{title}</span>
        <span>{formattedAmount}</span>
      </div>
      <div className={style.progress_container}>
        <ProgressBar
          completed={progress}
          bgColor={color}
          height="7px"
          isLabelVisible={false}
          baseBgColor={color + "33"}
          labelColor="#"
        />
      </div>
      <div className={style.stats}>
        {progress > 0 && <span>{progress}% of all chargebacks</span>}
        <span>
          {chargebacks > 0 ? numberOfChargebacks : getNoChargebacks()}
        </span>
      </div>
    </div>
  );
};

export const ScoreItemSkeleton = () => {
  return (
    <div className={style.score_item}>
      <div className={style.title_amount}>
        <SkeletonLoader variant="text" width="100px" height="24px" />
        <SkeletonLoader variant="text" width="100px" height="24px" />
      </div>
      <div className={style.progress_container}>
        <SkeletonLoader variant="rectangular" width="100%" height="7px" />
      </div>
      <div className={style.stats}>
        <SkeletonLoader variant="text" width="120px" height="16px" />
      </div>
    </div>
  );
};

export default ScoreItem;
